<template>
    <div class="main-container">
        <breadcrumb :list="breadcrumbList" />
        <div class="margintop-32" />
        <tl-header type="h1">Tax Outside</tl-header>

        <search-dropdown style="margin-bottom: 20px;" placeholder="Search Employee" :employeeData="employeeData"
            :clearRequired="true" @getList="searchEmployeesByName($event)" @empselected="(emp) => selectedEmp(emp)" />
        <div v-if="showEmpDetails" class="employeeCard">
            <div class="empImage">
                <img src="@/assets/user.svg" class="employeeImage" alt="" />
            </div>
            <div class="employeeDetails">
                <div class="rowOneContent">
                    <div class="empDetails">
                        <div class="empContentdev">
                            <p class="empContent">Name:</p>
                            <p class="empContent">
                                <b>{{ EmployeeName }}</b>
                            </p>
                        </div>
                    </div>
                    <div class="rowOneContent">
                        <div class="empDetails">
                            <div class="empContentdev">
                                <p class="empContent">Employee Code:</p>
                                <p class="empContent">
                                    <b>{{ EmployeeCode }}</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showEmpDetails" class="employeeCard">
            <div class="table-div" ref="table_div">
                <data-table :columns="taxOutsideTableList" :tableData="selectedEmployeeTaxOutsideDetails"
                    :showinrow="true" @editStart="showEditPopup" :showedit="true" :with-form="false"
                    :showhistory="false" :showdelete="true" @delete="deleteItem">
                </data-table>
                <v-dialog v-model="showPopup" persistent max-width="800px">
                    <v-card>
                        <v-card-title>
                            <span class="headline" style="color: #34c0be; font-size: 19px !important;">Edit
                                Record</span>
                        </v-card-title>
                        <v-card-text>
                            <data-table :columns="taxOutsideEditList" :tableData="selectedEmployeeTaxOutsideDetails"
                                :showinrow="true" @editStart="false" :showedit="false" :with-form="false"
                                :showhistory="false" :showdelete="false">
                                <template v-slot:rowcontent="slotprops">
                                    <txt v-if="slotprops.value.column.key == 'month'" class="custom"
                                        v-model="slotprops.value.record[slotprops.value.column.key]"
                                        @input="(val) => saveValues(val, slotprops.value.record, 'month')"
                                        @blur="saveValuesFecthing(slotprops.value.record)" />
                                    <txt v-if="slotprops.value.column.key == 'year'" class="custom"
                                        v-model="slotprops.value.record[slotprops.value.column.key]"
                                        @input="(val) => saveValues(val, slotprops.value.record, 'year')"
                                        @blur="saveValuesFecthing(slotprops.value.record)" />
                                    <txt v-if="slotprops.value.column.key == 'tax_amount'" class="custom"
                                        v-model="slotprops.value.record[slotprops.value.column.key]" @change="(val) =>
                                            saveValues(
                                                slotprops.value.record[slotprops.value.column.key],
                                                slotprops.value.record,
                                                'tax_amount'
                                            )
                                            " @blur="saveValuesFecthing(slotprops.value.record)" />
                                </template>
                            </data-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <btn text="Cancel" type="secondary" @click="cancelEdit">Cancel</btn>
                            <btn text="Save" type="primary" @click="editTaxOutside">Save</btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <pop-up-message v-if="showConfirmDeletePopup" :message="'Are you sure you want to delete ?'"
                    :popupType="popupType" :popupHeaderMessage="'Confirm Delete'">
                    <template v-slot:bottomContent>
                        <btn-grp>
                            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
                            <popup-btn text="Delete" type="primary" @click="deleteEvent" />
                        </btn-grp>
                    </template>
                </pop-up-message>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
    data() {
        return {
            navList: [],
            formate: "",
            EmployeeName: "",
            EmployeeCode: "",
            formateLess: "",
            toast: false,

            taxOutsideEditList: [
                {
                    label: "Month",
                    key: "month"
                },
                {
                    label: "Year",
                    key: "year"
                },
                {
                    label: "Tax Amount",
                    key: "tax_amount"
                },
            ],
            taxOutsideTableList: [
                {
                    label: "Month",
                    key: "month"
                },
                {
                    label: "Year",
                    key: "year"
                },
                {
                    label: "Tax Amount",
                    key: "tax_amount"
                },
                {
                    label: "Status",
                    key: "status"
                },
                {
                    label: "Created At",
                    key: "formattedCreatedDate"
                },
                {
                    label: "Updated At",
                    key: "formattedUpdatedDate"
                },
            ],
            showEmpDetails: false,
            employeeData: [],
            schedeleCode: '',
            selectedEmployeeData: [],
            selectedEmployeeTaxOutsideDetails: [],
            formattedCreatedDate: '',
            showUploadDocuments: false,
            employeeDocs: [],
            currentObj: {},
            updatedRecord: [],
            showPopup: false,
            contentId: '',
            editedRecord: null,
            popupType: "ConfirmDelete",
            showConfirmDeletePopup: false,
            data: {},
            empId: null,
            breadcrumbList: [
                {
                    name: "Payroll",
                    url: `/dashboard/${this.$route.params.entity_index}/payroll`
                },
                {
                    name: "Tax Outside",
                    url: ``
                }
            ],

        };
    },
    activated() {
        this.toast = false;
        this.errmsg = "";
        this.le = this.leId();
    },
    computed: {
        ...mapState("onboard/ctcslab", {
            ctcSlabsDataAll: (state) => state.entityWiseData,
        }),
        ...mapGetters({
            getleid: "onboard/legal_entities/legal_entity_ID",
        }),
        leId() {

            this.formate = new Intl.NumberFormat('en-in', {
                currency: "INR",
                style: "currency"
            });
            this.formateLess = new Intl.NumberFormat('en-in');
            if (this.$route.params.entity_index) {
                return this.getleid(this.$route.params.entity_index);
            }
            return this.getleid(0);

        },

        CTCslabID() {

            return this.ctcSlabsDataAll[this.leId];
        },
        requestParams() {
            return {
                leId: this.leId,
            };
        },
    },
    created: {
    },
    methods: {
        ...mapActions({
            fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
            fetchByInstallationStatus: "globalapi/globalemployees/fetchByInstallationStatus",

            fetchEmployeeDocumentsByEmployeeId:
                "dashboard/organisation/employeeDocument/fetchEmployeeByID",
            fetchByTaxOutside: "globalapi/globalemployees/fetchByTaxOutside",
            fectchEditTaxOutside: "globalapi/globalemployees/fectchEditTaxOutside",

            deleteTaxtOutside: "globalapi/globalemployees/deleteTaxtOutside"
        }),
        refresh() {
            try {
                this.showEmpDetails = false;
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },
        async searchEmployeesByName(val) {
            try {

                let res = await this.fetchEmployeeByLeAndName({
                    le_id: this.leId,
                    key: val,
                });
                this.employeeData = res.data.payload;
                this.EmployeeName = res.data.payload[0].first_name
                this.EmployeeCode = res.data.payload[0].code
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },
        loadEmployeeDocuments(res) {
            let documentList = [];
        },
        async loadDocuments() {
            let res = await this.fetchEmployeeDocumentsByEmployeeId({
                data: { employee_id: this.empId },
            });
            this.employeeDocs = [];
            this.loadEmployeeDocuments(res);
            this.showUploadDocuments = !this.showUploadDocuments;
        },

        async selectedEmp(emp) {
            try {
                this.employeeDocs = [];
                this.data = emp;
                this.empId = emp.id;
                let res = await this.fetchEmployeeDocumentsByEmployeeId({
                    data: { employee_id: emp.id },
                });
                // this.fetchInstallation()
                this.fetchAllTaxOutside()
                this.loadEmployeeDocuments(res);
                this.showEmpDetails = true;
                // this.fetchAllFbpLockDetails();
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },
        async fetchAllTaxOutside() {
            try {
                let res = await this.fetchByTaxOutside({
                    data: { employee_id: this.empId, page: 1, limit: 10 }
                })

                this.selectedEmployeeTaxOutsideDetails = res.data.payload

                this.formattedCreatedDate = res.data.payload[0].created_at
                this.contentId = res.data.payload[0].id
                console.log(this.contentId, 'this.contentId')
                console.log(this.formattedCreatedDate, 'this.formattedCreatedDate')
                this.formatDate()
                this.selectedEmployeeTaxOutsideDetails.forEach(item => {
                    console.log(item.created_at, 'item.created_at')
                    item.formattedCreatedDate = this.formatDate(item.created_at);
                    console.log(item.formattedCreatedDate, 'item.formattedCreatedDate')
                    item.formattedUpdatedDate = this.formatDate(item.updated_at);
                });
                console.log(this.selectedEmployeeTaxOutsideDetails, 'this.selectedEmployeeTaxOutsideDetails')
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },
        formatDate(dateStr) {
            const date = new Date(dateStr);

            // Convert the date to IST
            const offset = date.getTimezoneOffset() / 60;
            const istOffset = 5.5;
            const istDate = new Date(date.getTime() + ((istOffset + offset) * 60 * 60 * 1000));

            // Format the date to yyyy-mm-dd
            const yyyy = istDate.getFullYear();
            const mm = String(istDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const dd = String(istDate.getDate()).padStart(2, '0');

            return `${yyyy}-${mm}-${dd}`;
        },
        cancelEdit() {
            this.showPopup = false;
            this.editedRecord = null;
        },
        showEditPopup(record) {
            this.showPopup = true;
            this.editedRecord = { ...record };
        },
        saveValuesFecthing(record) {
            this.editedRecord = { ...record };
        },
        saveValues(newValue, record, key) {
            this.editedRecord[key] = newValue; // Update the edited record with the new value
        },

        async editTaxOutside() {
            try {
                let payloadData = {
                    content_id: this.contentId,
                    tax_amount: this.editedRecord.tax_amount,
                    month: this.editedRecord.month,
                    year: this.editedRecord.year
                }
                let res = await this.fectchEditTaxOutside(payloadData);
                this.showPopup = false;
                this.fetchAllTaxOutside()
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },
        deleteItem(item) {
            this.currentObj = item;
            this.showConfirmDeletePopup = true;
        },
        async deleteEvent() {
            try {
                let payloadData = {
                    content_id: this.currentObj.id,
                }
                let res = await this.deleteTaxtOutside(payloadData);
                this.showConfirmDeletePopup = false;
                this.fetchAllTaxOutside()
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },
        /* function to hide delete confirmation pop-up */
        cancelEvent() {
            this.showConfirmDeletePopup = false;
        },

    }

}
</script>

<style lang="scss" scoped>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.selectDrop {
    width: 130px !important;
}

.employeeCard {
    background-color: #f0f1f5;
    display: flex;
}

.employeeImage {
    height: 8rem;
    width: 8rem;
    margin: 20px;
}

.employeeDetails {
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    //gap: 20px;
}

::v-deep .datatable-outer-container table.datatable .header-row th {
    width: 400px
}

.empDetails {
    background-color: white;
    width: 14rem;
    border-radius: 6px;
    box-shadow: #e5e7f8 2px 4px 3px;
}

.empContentdev {
    padding: 5px 12px;
    position: relative;
}

.empContent {
    margin-bottom: 2px;
    font-size: 12px;
}

.rowOneContent {
    display: flex;
    gap: 12px;
}
</style>